// client/src/api/mealApi.js - API des plans de repas
import api from './api';

// Créer un nouveau plan de repas
export const createMealPlan = async (days) => {
  const response = await api.post('/api/meals', { days });
  return response.data;
};

// Récupérer tous les plans de repas
export const getMealPlans = async (page = 1, limit = 10) => {
  const response = await api.get('/api/meals', {
    params: { page, limit },
  });
  return response.data;
};

// Récupérer un plan de repas spécifique
export const getMealPlanById = async (id) => {
  const response = await api.get(`/api/meals/${id}`);
  return response.data;
};

// Mettre à jour un plan de repas
export const updateMealPlan = async (id, data) => {
  const response = await api.put(`/api/meals/${id}`, data);
  return response.data;
};

// Suggérer des recettes anti-gaspi
export const suggestAntiWasteRecipes = async (ingredients) => {
  const response = await api.post('/api/meals/anti-waste', { ingredients });
  return response.data;
};